import { Box, Skeleton } from "@mui/material";
import { QuickRepliesSkeleton } from "../QuickReplies";

// Mirrors RequestChatPanel's initial state: title, a single opening question
// anchored above the composer with AI topic chips, then the caption.
const NormalRequestSkeleton = () => {
  return (
    <Box
      data-request-chat-content
      sx={{
        display: "flex",
        flexDirection: "column",
        height: { xs: "auto", md: 650 },
        minHeight: { xs: "auto", md: 650 },
      }}
    >
      {/* Panel title */}
      <Skeleton
        variant="text"
        width="80%"
        height={44}
        sx={{ mb: 1, display: { xs: "none", md: "block" } }}
      />

      {/* Opening question */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          flex: 1,
          mb: 1.5,
        }}
      >
        <Skeleton variant="text" width={42} height={18} sx={{ mb: 0.25 }} />
        <Skeleton variant="text" width="75%" height={22} />
        <QuickRepliesSkeleton />
      </Box>

      {/* Composer */}
      <Box sx={{ position: "relative" }}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={42}
          sx={{ borderRadius: "9999px" }}
        />
        <Skeleton
          variant="circular"
          width={30}
          height={30}
          sx={{ position: "absolute", right: 6, bottom: 6 }}
        />
      </Box>

      {/* Caption */}
      <Skeleton
        variant="text"
        width="45%"
        height={18}
        sx={{ mt: 1, mx: "auto", display: { xs: "none", sm: "block" } }}
      />
    </Box>
  );
};

export default NormalRequestSkeleton;
